<template>
  <!-- this is renderless component that keeps us locked to the live lot when in live mode -->
  <span class="hidden" />
</template>

<script>
export default {
  name: "LiveMode",
  data() {
    return {};
  },

  computed: {
    // the pusher settings from the store
    currentLiveInventoryId: function () {
      return this.$store.getters.currentLiveInventoryId;
    },

    creditCardFormIsOpenInBiddingArea: function () {
      return this.$store.getters.creditCardFormIsOpenInBiddingArea;
    },

    // tells us if we are following the live auction (live mode)
    liveMode: function () {
      return this.$store.getters.liveMode;
    },

    // the item we are viewing now
    viewingInventoryId: function () {
      return this.getUrlParameter("inventoryId");
    },
  },

  watch: {
    // the current live inventory id has changed
    currentLiveInventoryId: function () {
      // get the new item for the store
      const itemIds = [];
      if (this.currentLiveInventoryId) {
        itemIds.push(this.currentLiveInventoryId);
      }
      this.$store.dispatch("getItems", { item_ids: itemIds });

      // the current live inventory id is not the one they are viewing
      if (this.currentLiveInventoryId != this.viewingInventoryId) {
        // the current live inventory is not null
        if (typeof this.currentLiveInventoryId !== null) {
          // we are in live mode
          if (this.liveMode && this.creditCardFormIsOpenInBiddingArea === false) {
            // advance us forward
            this.goToLiveLot(this.currentLiveInventoryId);
          }
        }
      }
    },

    creditCardFormIsOpenInBiddingArea: function () {
      return this.$store.getters.creditCardFormIsOpenInBiddingArea;
    },

    liveMode: function () {},
  },

  mounted() {
    // there is a navigation hide container element in the dom
    if (document.getElementById("navigationHideContainer")) {
      // store that element
      let navigationHideContainer = document.getElementById("navigationHideContainer");

      // we are in live mode
      if (this.liveMode) {
        // hide the navigation container
        navigationHideContainer.classList.add("hidden");

        // we are not in live mode
      } else {
        // do not hide the navigation container
        navigationHideContainer.classList.remove("hidden");
      }
    }
  },

  created() {},

  methods: {
    getUrlParameter: function (name) {
       
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      var results = regex.exec(location.search);
      return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    },

    goToLiveLot: function (inventoryId) {
      // establish a random wait time so that we don't hit the frontends at the exact same time
      // when advancing a lot during a live sale
      let minWait = Math.ceil(330);
      let maxWait = Math.floor(1330);
      let randomWait = Math.floor(Math.random() * (maxWait - minWait)) + 330;

      // wait 100ms and add the long delay class and remove the short delay
      setTimeout(function () {
        overlayFader.classList.add("longDelay");
        overlayFader.classList.remove("shortDelay");
      }, 100 + randomWait);

      // there is an overlay fader element that allows us to fade out from an item before
      // redirecting them to the next lot (which will fade in)
      let overlayFader = document.getElementById("overlayFader");

      // wait 2000ms and remove the transparent class, causing it to fade to opaque
      setTimeout(function () {
        overlayFader.classList.remove("transparent");
      }, 2000 + randomWait);

      // wait 3000ms and send them to the next lot
      setTimeout(function () {
        // If inventoryId is null, live mode is over, go to the home page
        if (!inventoryId || isNaN(inventoryId) || inventoryId < 1) {
          // Go to the home page
          window.location.href = '/'
          return
        }
        window.location.href =
          "/items/" +
          inventoryId +
          "/" +
          "?advanceWithPodium=true&inventoryId=" +
          inventoryId;
      }, 2330 + randomWait);
    },
  },
};
</script>
<style></style>
